export const CIG_SSO = {
    sessionKey: '_tqs',
    ssoUrl: '/oci/tenantnav',
    tenantId: 'tenantId',
    cookiesKey: '_id',
    ociSite: 'site',
    cookieJWT: '_cig',
    contextCookie: '_cigac',
    randomKey: '_rstr',
    tokenExpiresExt: '_exp',
    tokenVal: 'tkv',
    historyState: 'cighs',
    historyUrl: 'cigurl',
    PUB_KEY_MOD: '_cigmod',
    subject: '_cigsub',
    logout: 'logout',
};
export const CREATING_TENANT_COOKIE_PREFIX = 'cigct_'; // Cookie for create tenant
export const DEFAULT_CREATING_TENANT_COOKIE_MAXAGE = 10 * 60; // 10 minutes
export const CREATING_TENANT_LOCK_COOKIE_MAXAGE = 2 * 60; //2 minutes
export const CREATE_TENANT_LOCK = '_cigtenant_lock';
export const TENANT_LOCATION_LOCK = '_cigTenantLocation_lock';

export const OCI_SSO = {
    ssoApi: '/rest/v1/ssologin',
    ociRedirect: 'redirect',
    webuiToken: 'wtk',
    appId: 'applicationId',
    reportingApi: '/bi/completeAuth.jsp',
    ssoSessionId: 'gwssosessionid',
};

export const CIG_AUTH_PARAMS = {
    pathName: 'pathname',
    queryStr: 'querystr',
};

export const PRODUCT_TYPE = 'productType';
export const CI_PRODUCT = 'CI';
export const CS_PRODUCT = 'CS';

export const APPLICATION_ID = 'applicationId';
export const REPORTING_APP_ID = 'REPORTING';
export const UI_MODE_PARAM = 'uiMode';

export const CIG_PROD_MOD = ['PROD','PREVIEW'];
export const REST_API = '/rest/v1';
export const ONE_DAY_IN_MILLSECS = 86400*1000; // 1 day in milliseconds
export const SIX_HOURS_IN_MILLSECS = 6*60*60*1000; // 6 hours in milliseconds

export const PUBKEY_OBJ = {
    exp: '',
    subkey: '',
    keyInfo : '',
};
export const SUPPORT_SITE = 'https://mysupport.netapp.com';
export const AUTH0_META_DATA = 'http://cloud.netapp.com/user_metadata';
export const AUTH0_COUNTRY_CODE = 'http://cloud.netapp.com/geo_country_code';

export const CM_PROD_URL = 'https://console.bluexp.netapp.com';
export const CM_STAGING_URL = 'https://staging.console.bluexp.netapp.com';
export const CM_CANVAS_URL = '/working-environments';

// 'Cuba','Iran, Islamic Republic of','North Korea','Sudan','Syria','Venezuela, Bolivarian Republic of'];
export const NOT_SUPPORTED_COUNTRY_CODE = ['cu','ir','kp','sd','sy','ve', 'ps'];


export const JOB_ROLES = ['Architect','Backup Administrator','C-Level Executive',
    'Consultant', 'Cloud Architect',
    'Database Administrator','Developer','DevOps/SW Engineer','Director','Director IT Data Center',
    'Director Non-Technical','IT Staff Procurement','IT Storage Administrator',
    'Manager','Manager IT','Manager IT Procurement','Manager IT Storage',
    'Other - Non-Technical','Other - Technical','Site Reliability Engineer (SRE)', 'Vice President'];

// UI key for server logging
export const LOG_SERVER_KEY = 'a8aa88dc-b312-11e9-a2a3-2a2ae2dbcce4';
export const UILOG_MAX_MESSAGE_LENGTH = 1024;

export const MARKETING = {
    campaignSessionKey: 'cigcid', // Session storage key for marketing campaign id and reference source for Eloqua
}

export const DOC_CENTER_URL = 'https://docs.netapp.com/us-en/cloudinsights';
export const DOC_CENTER_REGION_PATH = '/security_information_and_region.html';
export const DOC_CENTER_TROUBLESHOOT_PATH = '/task_troubleshooting_general_problems.html';
export const MARKETING_LINK = 'https://cloud.netapp.com/cloud-insights';

export const AUTH0 = 'AUTH0';
export const GATEWAY_TENANT_ID = 'gateway-internal-tenant-id';
export const GATEWAY_REDIRECT_ID = 'gateway-internal-redirect-id';

export const UI_MODE = {
    KEY: 'mode',
    CM_MODE: 'CM',
    STANDALONE_MODE: 'STANDALONE',
    TENANT_TYPE_CI: 'CI',
    TENANT_TYPE_CS: 'CS',
    TENANT_TYPE_ONTAP: 'ONTAP',
};

export const TOS_ACCEPTANCE_SESSION_TIMOUT_IN_MILLI = 900 * 1000; // 15 minutes

export const CLOUD_TYPE = '_cloudtype';
export const PAGE_NOT_FOUND_QUERY_KEY = 'uri';
